// extracted by mini-css-extract-plugin
export default {"pagination":"List_pagination__6CklT","paginationButton":"List_paginationButton__cQ4RD","paginationInfo":"List_paginationInfo__nYik+"};